import { render, staticRenderFns } from "./groupApproval.vue?vue&type=template&id=03ae290f&scoped=true&"
import script from "./groupApproval.vue?vue&type=script&lang=js&"
export * from "./groupApproval.vue?vue&type=script&lang=js&"
import style0 from "./groupApproval.vue?vue&type=style&index=0&id=03ae290f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ae290f",
  null
  
)

export default component.exports